import { useEffect, useState } from "react";
import {
  Breadcrumb,
  Typography,
  Image,
  Layout,
  Spin,
  Card,
  Row,
  Col,
  List,
  Button,
  Divider,
} from "antd";
import { SendOutlined } from "@ant-design/icons";

import { useNavigate, useParams } from "react-router-dom";
import { useHttp } from "../../../../utils/DataHendler";
import CustomHeader2 from "../../../landingpage/Header/CustomHeader2";
import { Footers } from "../../../Footers";
import { formatDate } from "../../../../utils/DateTime";

const { Title, Text, Paragraph } = Typography;
const { Content } = Layout;

const IntershipDetail = () => {
  const navigate = useNavigate();

  const [detailData, setDetailData] = useState([]);
  const [loading, setLoading] = useState(false);
  const { getData } = useHttp();
  const { id } = useParams();

  useEffect(() => {
    getEvent();
  }, [id]);

  const getEvent = async () => {
    setLoading(true);
    try {
      const response = await getData(`/job/${id}`, {}, true);
      const data = response.data;
      setDetailData(data);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
    >
      <CustomHeader2 />

      {/* Breadcrumb */}
      <div style={{ padding: "16px 24px 0 24px" }}>
        <Breadcrumb>
          <Breadcrumb.Item>
            <a onClick={() => navigate("/")}>Home</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <a onClick={() => navigate("/career")}>Career</a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Detail Career</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <Layout style={{ background: "#f9f9f9", padding: "24px 0", flex: 1 }}>
        <Content style={{ maxWidth: 1100, margin: "0 auto" }}>
          {loading ? (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  minHeight: "50vh",
                }}
              >
                <Spin size="large" />
              </div>
            </>
          ) : (
            <>
              {/* Hero Image */}
              <Card
                bordered={false}
                style={{
                  marginBottom: 24,
                  overflow: "hidden",
                  borderRadius: 12,
                }}
                bodyStyle={{ padding: 0 }}
              >
                <div style={{ width: "100%", height: 350, overflow: "hidden" }}>
                  <Image
                    src={
                      detailData?.image_url ||
                      "https://via.placeholder.com/1000x400"
                    }
                    alt="Career Banner"
                    preview={true}
                    style={{
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      objectPosition: "center",
                      transform: "scale(1.05)",
                    }}
                  />
                </div>
              </Card>

              <Row gutter={24}>
                <Col xs={24} md={16}>
                  <Card
                    bordered={false}
                    style={{ borderRadius: 12, marginBottom: 24 }}
                  >
                    <Title level={2} style={{ marginBottom: 4 }}>
                      {detailData?.name}
                    </Title>
                    <Text type="secondary">
                      {formatDate(detailData?.created_at)}
                    </Text>

                    <Divider />

                    <div style={{ marginTop: 20, textAlign: "left" }}>
                      <Title level={5}>Requirements</Title>
                      <List
                        dataSource={detailData?.requirement}
                        renderItem={(req) => (
                          <List.Item>
                            <div>{req}</div>
                          </List.Item>
                        )}
                      />
                    </div>

                    <Divider />
                    <div style={{ marginTop: 20, textAlign: "left" }}>
                      <Title level={5}>Description</Title>
                      <Paragraph
                        style={{
                          textAlign: "justify",
                          fontSize: 15,
                          lineHeight: 1.8,
                        }}
                      >
                        {detailData?.description || "Tidak ada deskripsi."}
                      </Paragraph>
                    </div>
                  </Card>
                </Col>

                <Col xs={24} md={8}>
                  <Card
                    title="Informasi Pekerjaan"
                    bordered={false}
                    style={{
                      borderRadius: 12,
                      marginBottom: 24,
                      textAlign: "left",
                    }}
                  >
                    <p>
                      <strong>Kode:</strong> {detailData?.code || "-"}
                    </p>
                    <p>
                      <strong>Department:</strong>{" "}
                      {detailData?.department_name || "-"}
                    </p>
                    <p>
                      <strong>Kategori:</strong>{" "}
                      {detailData?.job_category_name || "-"}
                    </p>

                    <div style={{ marginTop: 16, textAlign: "center" }}>
                      <Button
                        type="primary"
                        icon={<SendOutlined />}
                        style={{
                          background:
                            "linear-gradient(135deg, #1679AB, #58A0C8)",
                          border: "none",
                          padding: "10px 24px",
                          borderRadius: 8,
                          fontWeight: "bold",
                          fontSize: 16,
                          boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                          transition: "all 0.3s ease",
                        }}
                        onMouseOver={(e) => {
                          e.currentTarget.style.transform = "translateY(-2px)";
                          e.currentTarget.style.boxShadow =
                            "0 6px 16px rgba(0,0,0,0.25)";
                        }}
                        onMouseOut={(e) => {
                          e.currentTarget.style.transform = "translateY(0)";
                          e.currentTarget.style.boxShadow =
                            "0 4px 12px rgba(0,0,0,0.15)";
                        }}
                      >
                        Apply Now
                      </Button>
                    </div>
                  </Card>
                </Col>
              </Row>
            </>
          )}
        </Content>
      </Layout>

      <Footers />
    </div>
  );
};

export default IntershipDetail;
